import { Datagrid, NumberField, ReferenceField, TextField } from 'react-admin';

export const PerformanceDataDatagrid: React.FC = () => {
  return (
    <Datagrid bulkActionButtons={false}>
      <TextField label="ID" source="id" />
      <TextField label="Meno" source="name" />
      <TextField label="Priezvisko" source="surname" />
      <ReferenceField label="E-mail" link="show" reference="Staff" source="id">
        <TextField source="user.email" />
      </ReferenceField>
      <NumberField label="Počet odoslaných pozvánok" source="sentUserInvitationsCount" />
      <NumberField label="Počet prijatých pozvánok" source="acceptedUserInvitationsCount" />
      <NumberField label="Počet klientov s pripojeným účtom" source="accountClientsCount" />
      <NumberField label="Počet klientov s Finoptio výstupom" source="finoptioReportClientsCount" />
      <NumberField label="Počet klientov s doplneným produktom" source="productClientsCount" />
      <NumberField label="Počet klientov s Fintelligence výstupom" source="fintelligenceReportClientsCount" />
    </Datagrid>
  );
};
